import script from "./VideoCaptionRow.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCaptionRow.vue?vue&type=script&setup=true&lang=js"

import "./VideoCaptionRow.vue?vue&type=style&index=0&id=253aa4dc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-253aa4dc"]])

export default __exports__